<script setup>
import { Icon, TimePicker, Label, Button, Input } from '@components'
import { ref, computed, onMounted, watch } from 'vue'

import { useRouter, useRoute } from 'vue-router'
const route = useRoute()
const router = useRouter()

import { sortedDays } from '@utils'
import moment from 'moment'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    },
    title: {
        type: String,
        default: 'Custom schedule'
    }
})


// const setTime = ref({
//     start: '',
//     end: ''
// })

// watch(setTime.value, (newValue) => {
//     console.log('setTimeChange', newValue)
// })

const activeDate = ref({
    title: '',
    from: {},
    to: {},
    time: {
        start: '12:00 AM',
        end: '11:55 PM'
    }
})

const date = computed({
    get: () => {
        // activeDate.value['from'] = {
        //     date: moment(props.modelValue.from, 'YYYY-MM-DD').date(),
        //     day: moment(props.modelValue.from, 'YYYY-MM-DD').day(),
        //     month: moment(props.modelValue.from, 'YYYY-MM-DD').month(),
        //     year: moment(props.modelValue.from, 'YYYY-MM-DD').year(),
        //     fullDate: moment(props.modelValue.from, 'YYYY-MM-DD').format('YYYY-MM-DD')
        // }

        // if (props.modelValue.to) {
        //     activeDate.value['to'] = {
        //         date: moment(props.modelValue.to, 'YYYY-MM-DD').date(),
        //         day: moment(props.modelValue.to, 'YYYY-MM-DD').day(),
        //         month: moment(props.modelValue.to, 'YYYY-MM-DD').month(),
        //         year: moment(props.modelValue.to, 'YYYY-MM-DD').year(),
        //         fullDate: moment(props.modelValue.to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        //     }
        // }
        // console.log('get', props.modelValue)
        return props.modelValue
    },
    set: (newValue) => {
        console.log(newValue)
        emit('update:modelValue', newValue)
    }
})

// Original day array
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const activeCalender = ref({
    month: 1, // Specify the month (1 for January, 2 for February, etc.)
    year: 0, // Specify the year
    dates: [],
})

const generateDates = () => {
    const firstDayOfMonth = moment(`${activeCalender.value.year}-${activeCalender.value.month}-01`, 'YYYY-MM-DD')
    const lastDayOfMonth = moment(firstDayOfMonth).endOf('month')

    const currentDate = moment(firstDayOfMonth)
    const startDayOfCalenderWeek = sortedDays()[0]
    const endDayOfCalenderWeek = sortedDays()[sortedDays().length - 1]

    activeCalender.value.dates = []

    // calculate the number of days to add at the beginning
    const daysToAddAtStart = (currentDate.day() + 7 - days.indexOf(startDayOfCalenderWeek)) % 7
    // add blank objects at the beginning
    let dateStartOfLastMonth = firstDayOfMonth.subtract(daysToAddAtStart, 'days')
    for (let i = 0; i < daysToAddAtStart; i++) {
        activeCalender.value.dates.push({
            day: dateStartOfLastMonth.format('dddd'),
            date: dateStartOfLastMonth.date(),
            month: dateStartOfLastMonth.format('MMMM'),
            year: dateStartOfLastMonth.format('YYYY'),
            fullDate: dateStartOfLastMonth.format('YYYY-MM-DD')
        })

        dateStartOfLastMonth.add(1, 'days')
    }

    while (currentDate.isSameOrBefore(lastDayOfMonth)) {
        activeCalender.value.dates.push({
            day: currentDate.format('dddd'),
            date: currentDate.date(),
            month: currentDate.format('MMMM'),
            year: currentDate.format('YYYY'),
            fullDate: currentDate.format('YYYY-MM-DD'),
        })

        currentDate.add(1, 'days')
    }

    // calculate the number of days to add at the end
    const daysToAddAtEnd = ((days.indexOf(endDayOfCalenderWeek) + 7 - currentDate.day()) % 7) + 1
    // add blank objects at the end
    if (daysToAddAtEnd > 6) return
    let dateEndOfLastMonth = lastDayOfMonth.add(1, 'days')
    for (let i = 0; i < daysToAddAtEnd; i++) {
        activeCalender.value.dates.push({
            day: dateEndOfLastMonth.format('dddd'),
            date: dateEndOfLastMonth.date(),
            month: dateEndOfLastMonth.format('MMMM'),
            year: dateEndOfLastMonth.format('YYYY'),
            fullDate: dateEndOfLastMonth.format('YYYY-MM-DD')
        })

        dateEndOfLastMonth.add(1, 'days')
    }
}



onMounted(() => {
    console.log('onMounted', props.modelValue)
    console.log('onMounted', props.modelValue.from.fullDate)
    if (!props.modelValue.from.fullDate) {
        console.log('onMounted', props.modelValue)
        activeDate.value.title = ''
        activeDate.value.from = {
            day: moment().format('dddd'),
            date: moment().date(),
            month: moment().format('MMMM'),
            year: moment().year(),
            fullDate: moment().format('YYYY-MM-DD'),
        }
        console.log(activeDate.value.from)
        activeCalender.value.month = new Date().getMonth() + 1
        activeCalender.value.year = new Date().getFullYear()

    } else {
        activeDate.value = props.modelValue

        activeCalender.value.month = moment(props.modelValue.from.fullDate, 'YYYY-MM-DD').month() + 1
        activeCalender.value.year = moment(props.modelValue.from.fullDate, 'YYYY-MM-DD').year()
    }
    //  else {
    //     activeDate.value.from = {
    //         day: moment(props.modelValue.from, 'YYYY-MM-DD').format('dddd'),
    //         date: moment(props.modelValue.from, 'YYYY-MM-DD').date(),
    //         month: moment(props.modelValue.from, 'YYYY-MM-DD').format('MMMM'),
    //         year: moment(props.modelValue.from, 'YYYY-MM-DD').year(),
    //         fullDate: moment(props.modelValue.from, 'YYYY-MM-DD').format('YYYY-MM-DD'),
    //     }
    // }


    // if (props.modelValue.to) {
    //     activeDate.value.to = {
    //         day: moment(props.modelValue.to, 'YYYY-MM-DD').format('dddd'),
    //         date: moment(props.modelValue.to, 'YYYY-MM-DD').date(),
    //         month: moment(props.modelValue.to, 'YYYY-MM-DD').format('MMMM'),
    //         year: moment(props.modelValue.to, 'YYYY-MM-DD').year(),
    //         fullDate: moment(props.modelValue.to, 'YYYY-MM-DD').format('YYYY-MM-DD'),
    //     }
    // }

    date.value = activeDate.value
})

const divideArrayIntoGroups = (array, groupSize) => {
    const resultArray = []
    for (let i = 0; i < array.length; i += groupSize) {
        resultArray.push(array.slice(i, i + groupSize))
    }
    return resultArray
}

const getDates = computed(() => {
    generateDates()
    return divideArrayIntoGroups(activeCalender.value.dates, 7)
})

const isActive = (date) => {
    if (!date) return

    // if date match with from or to active date
    return date.day == activeDate.value.from.day && date.date == activeDate.value.from.date && date.month == activeDate.value.from.month && date.year == activeDate.value.from.year
        || date.day == activeDate.value.to.day && date.date == activeDate.value.to.date && date.month == activeDate.value.to.month && date.year == activeDate.value.to.year
}

const isBetweenActive = (date) => {
    if (!date) return

    let startDate = moment(`${activeDate.value.from.year}-${activeDate.value.from.month}-${activeDate.value.from.date}`, 'YYYY-MMM-DD')
    let endDate = moment(`${activeDate.value.to.year}-${activeDate.value.to.month}-${activeDate.value.to.date}`, 'YYYY-MMM-DD')
    let currentDate = moment(`${date.year}-${date.month}-${date.date}`, 'YYYY-MMM-DD')

    if (startDate.isAfter(endDate)) {
        console.log('start date is after end date')
        let temp = {
            from: activeDate.value.from,
            to: activeDate.value.to
        }
        // Swap values
        activeDate.value.from = temp.to
        activeDate.value.to = temp.from
        return isBetweenActive(date)
    }

    return currentDate.isBetween(startDate, endDate, null, '[]')
}

const changeMonth = (option) => {
    if (!option) return

    const currentMonth = moment({
        year: activeCalender.value.year,
        month: activeCalender.value.month - 1, // Moment.js months are 0-based
    })

    // get the details of next or prev month
    const changeMonthTo = option == 'next' ? currentMonth.clone().add(1, 'month') : currentMonth.clone().subtract(1, 'month')

    activeCalender.value.month = changeMonthTo.month() + 1
    activeCalender.value.year = changeMonthTo.year()
    activeCalender.value.dates = []

    generateDates()
}

const selectDate = (date) => {
    if (!date.fullDate) return
    console.log({
        date: date,
        activeDate: activeDate.value
    })
    if (activeDate.value.from.date == date.date) {
        return activeDate.value.to = date
    }

    activeDate.value.from = date
    // activeDate.value.time = setTime.value
}


watch(activeDate.value, (newValue) => {
    date.value = newValue
})



</script>

<template>
    <div class="md:w-[446px] m-auto">
        <div class="text-[#344054] text-2xl font-semibold mb-6">{{ props.title }}</div>


        <!-- {{ activeDate }} -->
        <div class="w-full mb-5">
            <Label>Title</Label>
            <Input v-model="activeDate.title" placeholder="ex. Independence day" type="text" size="sm" class="mt-1.5"></Input>
        </div>
        <div class="flex flex-col gap-5 overflow-scroll md:flex-row md:overflow-visible">
            <!-- calender -->
            <div class="w-[446px] p-6 border border-[#EAECF0] rounded-lg" title="Double click for range selection">
                <!-- <div class="w-full p-6 border border-[#EAECF0] rounded-lg" title="Double click for range selection"> -->
                <!-- header -->
                <div class="flex items-center justify-between">
                    <Icon name="chevronLeft" size="36px" class="cursor-pointer p-2 text-[#667085]" @click="changeMonth('prev')"></Icon>
                    <div class="text-[#344054] text-base font-semibold">{{ moment(`${activeCalender.month}-${activeCalender.year}`, 'MM-YYYY').format('MMMM YYYY') }}</div>
                    <Icon name="chevronRight" size="36px" class="cursor-pointer p-2 text-[#667085]" @click="changeMonth('next')"></Icon>
                </div>

                <div class="flex items-center gap-3">
                    <div :class="activeDate.to.date ? 'w-[182px]' : 'w-full'" class="rounded-lg border border-[#D0D5DD] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] p-[8px_12px] text-[#101828] text-base font-normal mt-3">{{ moment(`${activeDate.from.year}-${activeDate.from.month}-${activeDate.from.date}`, 'YYYY-MMM-DD').format('MMM D, YYYY') }}</div>
                    <div v-if="activeDate.to.date" class="mt-3">-</div>
                    <div class="w-[182px] rounded-lg border border-[#D0D5DD] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] p-[8px_12px] text-[#101828] text-base font-normal mt-3" v-if="activeDate.to.date">{{ moment(`${activeDate.to.year}-${activeDate.to.month}-${activeDate.to.date}`, 'YYYY-MMM-DD').format('MMM D, YYYY') }}</div>
                </div>

                <!-- day -->
                <div class="flex items-center justify-between mt-3">
                    <div v-for="day in sortedDays()" class="text-[#344054] text-sm font-medium p-[10px_8px_12px_8px]">{{ day.slice(0, 3) }}</div>
                </div>
                <div v-for="(row, index) in getDates" :key="index">
                    <div class="flex items-center justify-between mt-1 mb-1 text-center last:mb-0">
                        <div v-for="item in row" class="w-[40px] h-[40px] p-[10px_8px_12px_8px] text-sm leading-normal rounded-[20px]" :class="[isActive(item) ? ' !bg-[#7F56D9] text-[#FFF] font-medium' : 'text-[#344054] font-normal'], { 'bg-[#F9F5FF]': isBetweenActive(item) && !isActive(item) }, { 'cursor-pointer': item.fullDate }, { 'hover:bg-[#F9F5FF]': !isActive(item) && item.fullDate }" @click="selectDate(item)">{{ item.date, item.fullDate }}</div>
                    </div>
                </div>

            </div>

            <!-- time -->
            <!-- <div class="w-full md:w-[270px] p-6 border border-[#EAECF0] rounded-lg">
                <div class="flex flex-col gap-1">
                    <div class="text-[#101828] text-lg font-semibold">Set time</div>
                    <div class="text-[#667085] text-sm font-normal">Assign start and finish time for staff</div>
                </div>

                <div class="mt-5">
                    <div class="w-full mb-5">
                        <Label>Start</Label>
                        <TimePicker v-model="activeDate.time.start" class="mt-1.5" placeholder="From" format="12" />
                    </div>
                    <div class="w-full">
                        <Label>Finish</Label>
                        <TimePicker v-model="activeDate.time.end" class="mt-1.5" placeholder="Finish" format="12" />
                    </div>

                </div>
            </div> -->
        </div>
    </div>
</template>


<style>

</style>